import axios from 'axios';
import { getCurrentLanguage } from 'tradera-lang/boot-languages';
import { toLocalizedUrl } from 'tradera-utils/url';
import { setEnvironmentHash, setIsSpaNavigationEnabled } from './reducer';

export const initialize = () => ({});

export const updateEnvironmentHash = () => async (dispatch, getState) => {
    const url = toLocalizedUrl('/ping', getCurrentLanguage());
    const response = await axios.get(url);
    const environmentHash = response.headers['x-tradera-environment'];
    const current = getState().environment.environmentHash;
    if (environmentHash !== current) {
        dispatch(setEnvironmentHash(environmentHash));
        dispatch(setIsSpaNavigationEnabled(false));
    }
};
